export default __webpack_public_path__ + "static/media/events@1x.26b98f24.svg";